export default __webpack_public_path__ + "images/TF.4a1385b.png";